import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type BookingItemData = {};

export const initialBookingPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
